// TripPortal.jsx — שים ב: src/components/TripPortal.jsx
// npm install firebase (אם עוד לא)

import { useState, useEffect } from 'react';
import { initializeApp, getApps } from 'firebase/app';
import {
  getFirestore, collection, query, where, getDocs,
  doc, updateDoc, arrayUnion
} from 'firebase/firestore';

const firebaseConfig = {
  apiKey:            'AIzaSyAnUB-I7W_zrFz9aPNHMVnKFBW0mOqymwU',
  authDomain:        'megedigital-2051f.firebaseapp.com',
  projectId:         'megedigital-2051f',
  storageBucket:     'megedigital-2051f.firebasestorage.app',
  messagingSenderId: '869349495873',
  appId:             '1:869349495873:web:8e143ddb22acf42ef162c0',
};
const fbApp = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
const db    = getFirestore(fbApp);

const C = {
  navy: '#0D1F4A', blue: '#1B3F8B', mid: '#2952A3',
  beige: '#E8E0D5', gold: '#D4A017', grey: '#94A3B8',
  greyDk: '#475569', white: '#FFFFFF', green: '#22C55E', red: '#EF4444',
};

const fmtDate = (iso) => {
  if (!iso) return '';
  try { return iso.split('-').reverse().join('/'); } catch { return iso; }
};

const SESSION_KEY = 'meged_web_session';
const saveSession = (docId) => {
  const expiry = new Date(Date.now() + 30*24*60*60*1000).toISOString();
  localStorage.setItem(SESSION_KEY, JSON.stringify({ docId, expiry }));
};
const loadSession = () => {
  try {
    const s = JSON.parse(localStorage.getItem(SESSION_KEY) || '{}');
    if (s.docId && s.expiry && new Date() < new Date(s.expiry)) return s.docId;
  } catch {}
  return null;
};
const clearSession = () => localStorage.removeItem(SESSION_KEY);

// ── כפתור iOS — מוסיפים ל-AppSection ────────────────────
export function IOSPortalButton({ appLogo }) {
  const [open, setOpen] = useState(false);
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  if (!isIOS) return null;
  return (
    <>
      <button onClick={() => setOpen(true)}
        className="inline-flex items-center gap-4 bg-white border-2 border-brand-blue
          text-brand-blue px-5 py-4 rounded-2xl transition-all duration-200
          shadow-card hover:shadow-card-lg hover:-translate-y-0.5 group w-full md:w-auto mt-3">
        <div className="w-14 h-14 rounded-2xl bg-brand-blue/10 flex items-center justify-center flex-shrink-0 overflow-hidden">
          <img src={appLogo} alt="MegeDigital" className="w-12 h-12 object-contain" />
        </div>
        <div className="text-right flex-1">
          <div className="font-body text-[11px] text-brand-blue/60 font-light mb-0.5">למשתמשי iPhone</div>
          <div className="font-body font-bold text-[17px] leading-none">כניסה לתיק הטיול</div>
          <div className="font-body text-[11px] text-brand-blue/60 font-light mt-1">ללא הורדה</div>
        </div>
        <div className="bg-brand-blue/10 rounded-xl w-10 h-10 flex items-center justify-center
            group-hover:bg-brand-blue/20 transition-colors duration-200 flex-shrink-0">
          <span className="text-lg">🔐</span>
        </div>
      </button>
      {open && <TripPortalModal onClose={() => setOpen(false)} />}
    </>
  );
}

// ── Modal ─────────────────────────────────────────────────
function TripPortalModal({ onClose }) {
  const [screen, setScreen]   = useState('login');
  const [tripData, setTripData] = useState(null);
  const [docId, setDocId]     = useState(null);
  const [tab, setTab]         = useState('home');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const saved = loadSession();
    if (saved) { setDocId(saved); setScreen('pin'); }
  }, []);

  const handleLoginSuccess = (data, id) => {
    setTripData(data); setDocId(id);
    saveSession(id);
    setScreen('trip');
  };

  const handlePinSuccess = async (id) => {
    setLoading(true);
    try {
      const q = query(collection(db,'trips'), where('__name__','==',id));
      const snap = await getDocs(q);
      if (!snap.empty) { setTripData(snap.docs[0].data()); setScreen('trip'); }
    } catch {}
    setLoading(false);
  };

  const handleLogout = () => {
    clearSession(); setTripData(null); setDocId(null);
    setScreen('login'); setTab('home');
  };

  const refresh = async () => {
    if (!docId) return;
    setLoading(true);
    try {
      const q = query(collection(db,'trips'), where('__name__','==',docId));
      const snap = await getDocs(q);
      if (!snap.empty) setTripData(snap.docs[0].data());
    } catch {}
    setLoading(false);
  };

  return (
    <div style={{
      position:'fixed',inset:0,zIndex:9999,
      background:'rgba(0,0,0,0.75)',backdropFilter:'blur(6px)',
      display:'flex',alignItems:'flex-end',justifyContent:'center',
    }} onClick={e => { if (e.target===e.currentTarget) onClose(); }}>
      <div style={{
        background:C.navy,width:'100%',maxWidth:480,
        borderRadius:'24px 24px 0 0',maxHeight:'94vh',
        display:'flex',flexDirection:'column',overflow:'hidden',direction:'rtl',
      }}>
        {/* AppBar */}
        <div style={{
          background:C.blue,padding:'14px 18px',
          display:'flex',alignItems:'center',gap:10,
          borderBottom:'1px solid rgba(255,255,255,0.1)',flexShrink:0,
        }}>
          <span style={{fontSize:22}}>✈️</span>
          <div style={{flex:1}}>
            <div style={{color:C.white,fontWeight:700,fontSize:15}}>מגד שמיים</div>
            <div style={{color:C.grey,fontSize:11}}>
              {screen==='trip' ? tripData?.travelerName : 'תיק הטיול הדיגיטלי'}
            </div>
          </div>
          {screen==='trip' && (
            <button onClick={refresh}
              style={{background:'none',border:'none',color:C.grey,fontSize:20,cursor:'pointer',padding:4}}>
              ⟳
            </button>
          )}
          <button onClick={screen==='trip' ? handleLogout : onClose}
            style={{background:'none',border:'none',color:C.grey,fontSize:13,cursor:'pointer',padding:'4px 8px'}}>
            {screen==='trip' ? 'יציאה' : '✕'}
          </button>
        </div>

        {/* Content */}
        <div style={{flex:1,overflowY:'auto'}}>
          {loading && <div style={{padding:40,textAlign:'center',color:C.grey,fontSize:16}}>⏳ טוען...</div>}
          {!loading && screen==='login' && <LoginScreen onSuccess={handleLoginSuccess} />}
          {!loading && screen==='pin'   && (
            <PinScreen docId={docId} onSuccess={handlePinSuccess}
              onForgot={() => { clearSession(); setScreen('login'); }} />
          )}
          {!loading && screen==='trip' && tripData && (
            <TripViewer tripData={tripData} docId={docId} tab={tab} setTab={setTab} />
          )}
        </div>

        {screen==='trip' && <BottomNav tab={tab} setTab={setTab} />}
      </div>
    </div>
  );
}

// ── Login ─────────────────────────────────────────────────
function LoginScreen({ onSuccess }) {
  const [id, setId]       = useState('');
  const [pin, setPin]     = useState('');
  const [phone, setPhone] = useState('');
  const [err, setErr]     = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (id.length !== 9)     { setErr('מספר זהות: 9 ספרות'); return; }
    if (pin.length !== 4)    { setErr('PIN: 4 ספרות'); return; }
    if (phone.length !== 10) { setErr('טלפון: 10 ספרות'); return; }
    setLoading(true); setErr('');
    try {
      const snap = await getDocs(query(collection(db,'trips'), where('tripId','==',id)));
      if (snap.empty) { setErr('לא נמצא תיק טיול'); setLoading(false); return; }
      const docSnap = snap.docs[0];
      const data    = docSnap.data();
      if (data.lockedUntil && new Date() < new Date(data.lockedUntil)) {
        setErr('החשבון נעול. נסה מאוחר יותר'); setLoading(false); return;
      }
      if (data.authCode?.toString() !== pin) {
        await updateDoc(docSnap.ref, { loginAttempts: (data.loginAttempts||0)+1 });
        setErr('פרטים שגויים'); setLoading(false); return;
      }
      const saved  = (data.travelerPhone||'').replace(/[\s\-\+]/g,'').replace(/^972/,'0');
      const input  = phone.replace(/^972/,'0');
      if (saved !== input) { setErr('פרטים שגויים'); setLoading(false); return; }
      await updateDoc(docSnap.ref, { loginAttempts:0, lastLogin: new Date().toISOString() });
      onSuccess(data, docSnap.id);
    } catch(e) { setErr('שגיאה: '+e.message); }
    setLoading(false);
  };

  return (
    <div style={{padding:24}}>
      <div style={{textAlign:'center',marginBottom:28}}>
        <div style={{fontSize:40,marginBottom:8}}>🔐</div>
        <div style={{color:C.white,fontWeight:700,fontSize:20}}>כניסה לתיק הטיול</div>
        <div style={{color:C.grey,fontSize:13,marginTop:4}}>הזן את הפרטים שקיבלת מהסוכן</div>
      </div>
      <Fld label="מספר זהות" placeholder="9 ספרות" value={id} onChange={v=>setId(v.replace(/\D/g,'').slice(0,9))} mode="numeric" />
      <Fld label='קוד PIN' placeholder="4 ספרות" value={pin} onChange={v=>setPin(v.replace(/\D/g,'').slice(0,4))} mode="numeric" secret />
      <Fld label="טלפון" placeholder="05XXXXXXXX" value={phone} onChange={v=>setPhone(v.replace(/\D/g,'').slice(0,10))} mode="numeric" />
      {err && <ErrBox msg={err} />}
      <Btn label={loading ? 'מתחבר...' : 'כניסה לתיק הטיול'} onClick={handleLogin} disabled={loading} gold />
    </div>
  );
}

// ── PIN (session) ─────────────────────────────────────────
function PinScreen({ docId, onSuccess, onForgot }) {
  const [pin, setPin]   = useState('');
  const [err, setErr]   = useState('');
  const [loading, setLoading] = useState(false);

  const handlePin = async () => {
    if (pin.length !== 4) { setErr('PIN: 4 ספרות'); return; }
    setLoading(true); setErr('');
    try {
      const snap = await getDocs(query(collection(db,'trips'), where('__name__','==',docId)));
      if (snap.empty) { onForgot(); return; }
      if (snap.docs[0].data().authCode?.toString() !== pin) { setErr('קוד שגוי'); setLoading(false); return; }
      onSuccess(docId);
    } catch { setErr('שגיאה'); }
    setLoading(false);
  };

  return (
    <div style={{padding:24}}>
      <div style={{textAlign:'center',marginBottom:28}}>
        <div style={{fontSize:40,marginBottom:8}}>👤</div>
        <div style={{color:C.white,fontWeight:700,fontSize:20}}>ברוך השב</div>
        <div style={{color:C.grey,fontSize:13,marginTop:4}}>הזן קוד PIN לכניסה מהירה</div>
      </div>
      <Fld label="קוד PIN" placeholder="4 ספרות" value={pin} onChange={v=>setPin(v.replace(/\D/g,'').slice(0,4))} mode="numeric" secret />
      {err && <ErrBox msg={err} />}
      <Btn label={loading ? 'מתחבר...' : 'כניסה'} onClick={handlePin} disabled={loading} gold />
      <button onClick={onForgot} style={{width:'100%',background:'none',border:'none',color:C.grey,fontSize:13,cursor:'pointer',padding:10,marginTop:4}}>
        כניסה עם פרטים מלאים
      </button>
    </div>
  );
}

// ── TripViewer ────────────────────────────────────────────
function TripViewer({ tripData, docId, tab, setTab }) {
  if (tab==='home')      return <HomeTab      tripData={tripData} setTab={setTab} />;
  if (tab==='itinerary') return <ItineraryTab tripData={tripData} />;
  if (tab==='docs')      return <DocsTab      tripData={tripData} />;
  if (tab==='contacts')  return <ContactsTab  tripData={tripData} docId={docId} />;
  if (tab==='expenses')  return <ExpensesTab  tripData={tripData} docId={docId} />;
  return null;
}

// ── Home ──────────────────────────────────────────────────
function HomeTab({ tripData, setTab }) {
  const now     = new Date();
  const startDt = tripData.startDate ? new Date(tripData.startDate) : null;
  const endDt   = tripData.endDate   ? new Date(tripData.endDate)   : null;
  let status = '';
  if (startDt && endDt) {
    if (now < startDt) status = `עוד ${Math.ceil((startDt-now)/86400000)} ימים לטיול ✈️`;
    else if (now > endDt) status = 'הטיול הסתיים 🎉';
    else status = `יום ${Math.ceil((now-startDt)/86400000)} בטיול 🌍`;
  }
  const flights  = tripData.flights  || [];
  const docs     = tripData.documents|| [];
  const contacts = tripData.contacts || [];
  const expenses = tripData.expenses || [];

  return (
    <div style={{padding:20}}>
      {tripData.tripTitle && <div style={{color:C.gold,fontWeight:600,fontSize:13,marginBottom:4}}>{tripData.tripTitle}</div>}
      <div style={{color:C.white,fontWeight:800,fontSize:22,marginBottom:4}}>שלום, {tripData.travelerName}! 👋</div>
      {status && <div style={{color:C.grey,fontSize:13,marginBottom:16}}>{status}</div>}

      {/* כרטיס ראשי */}
      <div style={{
        background:`linear-gradient(135deg,${C.blue},${C.mid})`,
        borderRadius:20,padding:20,marginBottom:16,
        boxShadow:'0 8px 24px rgba(27,63,139,0.4)',
      }}>
        <div style={{color:C.white,fontWeight:900,fontSize:26,marginBottom:2}}>{tripData.destination}</div>
        {tripData.startDate && (
          <div style={{color:'rgba(255,255,255,0.55)',fontSize:12,direction:'ltr',textAlign:'right'}}>
            {fmtDate(tripData.startDate)} — {fmtDate(tripData.endDate)}
          </div>
        )}
        {flights.slice(0,2).map((f,i) => {
          if (!f.departureAirport || f.departureAirport===f.arrivalAirport) return null;
          const t = f.departureTime?.includes('T') ? f.departureTime.split('T')[1]?.slice(0,5) : f.departureTime?.slice(0,5);
          return (
            <div key={i} style={{
              background:'rgba(255,255,255,0.1)',borderRadius:12,padding:'10px 14px',marginTop:10,
              display:'flex',alignItems:'center',gap:8,
            }}>
              <span style={{color:'rgba(255,255,255,0.5)',fontSize:13}}>{i===0?'✈️':'🛬'}</span>
              <span style={{color:C.white,fontWeight:900,fontSize:18}}>{f.departureAirport}</span>
              <span style={{color:'rgba(255,255,255,0.35)',fontSize:11}}>→</span>
              <span style={{color:C.white,fontWeight:900,fontSize:18}}>{f.arrivalAirport}</span>
              {t && <span style={{color:C.beige,fontSize:11,marginRight:'auto'}}>{t}</span>}
            </div>
          );
        })}
      </div>

      {/* סטטס */}
      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10,marginBottom:16}}>
        {[
          {emoji:'🗺️',val:(tripData.itinerary||[]).length,label:'ימים',    tab:'itinerary'},
          {emoji:'📄',val:docs.length,                    label:'מסמכים',  tab:'docs'},
          {emoji:'👥',val:contacts.length,                label:'קשר',     tab:'contacts'},
          {emoji:'💸',val:expenses.length,                label:'הוצאות',  tab:'expenses'},
        ].map(({emoji,val,label,tab:t})=>(
          <button key={label} onClick={()=>setTab(t)} style={{
            background:'rgba(27,63,139,0.18)',border:'1px solid rgba(27,63,139,0.45)',
            borderRadius:14,padding:'14px 10px',cursor:'pointer',
            display:'flex',flexDirection:'column',alignItems:'center',gap:4,
          }}>
            <span style={{fontSize:20}}>{emoji}</span>
            <span style={{color:C.white,fontWeight:800,fontSize:20}}>{val}</span>
            <span style={{color:C.grey,fontSize:11}}>{label}</span>
          </button>
        ))}
      </div>

      {/* מלון */}
      {tripData.sharedHotel && tripData.sharedAccommodation?.hotelName && (
        <div style={{background:'rgba(27,63,139,0.18)',border:'1px solid rgba(27,63,139,0.45)',borderRadius:14,padding:14}}>
          <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:4}}>
            <span>🏨</span>
            <span style={{color:C.white,fontWeight:700}}>{tripData.sharedAccommodation.hotelName}</span>
          </div>
          {tripData.sharedAccommodation.checkoutTime && <div style={{color:C.grey,fontSize:12}}>Checkout: {tripData.sharedAccommodation.checkoutTime}</div>}
          {tripData.sharedAccommodation.freeCancellation!=null && (
            <div style={{fontSize:12,marginTop:4,color:tripData.sharedAccommodation.freeCancellation?'#34D399':C.red}}>
              {tripData.sharedAccommodation.freeCancellation?'✓ ביטול חינם':'✗ ללא ביטול חינם'}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// ── Itinerary ─────────────────────────────────────────────
function ItineraryTab({ tripData }) {
  const [openDay, setOpenDay] = useState(null);
  const itinerary = tripData.itinerary || [];
  const sharedAcc = tripData.sharedHotel ? tripData.sharedAccommodation : null;
  const car       = tripData.car;
  const lastIdx   = itinerary.length-1;

  return (
    <div style={{padding:16}}>
      {itinerary.map((day,i)=>{
        const acc  = day.accommodation?.hotelName ? day.accommodation : sharedAcc;
        const acts = (day.activities||[]).filter(a=>a.title||a.description);
        const isOpen = openDay===i;
        return (
          <div key={i} style={{
            background:'rgba(27,63,139,0.15)',border:'1px solid rgba(27,63,139,0.4)',
            borderRadius:14,marginBottom:10,overflow:'hidden',
          }}>
            <button onClick={()=>setOpenDay(isOpen?null:i)} style={{
              width:'100%',background:'none',border:'none',cursor:'pointer',
              padding:'12px 14px',display:'flex',alignItems:'center',gap:10,
            }}>
              <div style={{
                width:32,height:32,borderRadius:9,background:C.blue,flexShrink:0,
                display:'flex',alignItems:'center',justifyContent:'center',
                color:C.white,fontWeight:800,fontSize:13,
              }}>{i+1}</div>
              <div style={{flex:1,textAlign:'right'}}>
                <div style={{color:C.white,fontWeight:600,fontSize:14}}>{day.dayTitle||`יום ${i+1}`}</div>
                <div style={{color:C.grey,fontSize:11}}>{fmtDate(day.date)}</div>
              </div>
              <span style={{color:C.grey,fontSize:11}}>{isOpen?'▲':'▼'}</span>
            </button>
            {isOpen && (
              <div style={{padding:'0 14px 12px'}}>
                {car?.company && i===0 && <CarRow car={car} isPickup />}
                {acts.map((act,j)=>(
                  <div key={j} style={{display:'flex',gap:8,marginBottom:8,alignItems:'flex-start'}}>
                    {act.time && <span style={{background:'rgba(27,63,139,0.3)',borderRadius:7,padding:'2px 7px',color:C.white,fontSize:11,flexShrink:0}}>{act.time}</span>}
                    <div style={{flex:1}}>
                      {act.title && <div style={{color:C.white,fontWeight:600,fontSize:13}}>{act.title}</div>}
                      {act.description && <div style={{color:C.grey,fontSize:12}}>{act.description}</div>}
                      {act.mapsLink && <a href={act.mapsLink} target="_blank" rel="noopener noreferrer" style={{color:'#34D399',fontSize:12,display:'block',marginTop:4}}>📍 פתח במפות</a>}
                    </div>
                  </div>
                ))}
                {acc?.hotelName && (
                  <div style={{background:'rgba(27,63,139,0.25)',borderRadius:10,padding:10,marginTop:6,display:'flex',alignItems:'center',gap:8}}>
                    <span>🏨</span>
                    <div style={{flex:1}}>
                      <div style={{color:C.white,fontWeight:600,fontSize:13}}>{acc.hotelName}</div>
                      {acc.checkoutTime && <div style={{color:C.grey,fontSize:11}}>Checkout: {acc.checkoutTime}</div>}
                    </div>
                    {acc.bookingLink && <a href={acc.bookingLink} target="_blank" rel="noopener noreferrer" style={{color:'#60A5FA',fontSize:12}}>פתח</a>}
                  </div>
                )}
                {car?.company && i===lastIdx && <CarRow car={car} isPickup={false} />}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

function CarRow({ car, isPickup }) {
  const loc  = isPickup ? car.pickupLocation  : car.returnLocation;
  const maps = isPickup ? car.pickupMapsLink  : car.returnMapsLink;
  return (
    <div style={{background:`${C.gold}15`,border:`1px solid ${C.gold}40`,borderRadius:10,padding:10,marginBottom:8,display:'flex',alignItems:'center',gap:8}}>
      <span>{isPickup?'🚗':'🏁'}</span>
      <div style={{flex:1}}>
        <div style={{color:C.gold,fontWeight:600,fontSize:13}}>{isPickup?'איסוף':'החזרה'} — {car.company}</div>
        {loc && <div style={{color:C.grey,fontSize:12}}>{loc}</div>}
      </div>
      {maps && <a href={maps} target="_blank" rel="noopener noreferrer" style={{color:'#34D399',fontSize:18}}>📍</a>}
    </div>
  );
}

// ── Docs ──────────────────────────────────────────────────
function DocsTab({ tripData }) {
  const docs = tripData.documents||[];
  const CAT  = {flight:'✈️',insurance:'🛡️',passport:'🛂',hotel:'🏨',other:'📄'};
  const LBL  = {flight:'כרטיס טיסה',insurance:'פוליסת ביטוח',passport:'צילום דרכון',hotel:'אישור מלון',other:'מסמך'};
  if (!docs.length) return <Empty icon="📁" text="אין מסמכים בתיק" />;
  return (
    <div style={{padding:16}}>
      {docs.map((g,i)=>(
        <div key={i} style={{background:'rgba(27,63,139,0.15)',border:'1px solid rgba(27,63,139,0.4)',borderRadius:14,marginBottom:10,padding:14}}>
          <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:10}}>
            <span style={{fontSize:24}}>{CAT[g.category]||'📄'}</span>
            <span style={{color:C.white,fontWeight:700}}>{LBL[g.category]||'מסמך'}</span>
          </div>
          {(g.files||[]).map((f,j)=>(
            <div key={j} style={{background:'rgba(13,31,74,0.5)',borderRadius:10,padding:'10px 12px',display:'flex',alignItems:'center',gap:8,marginBottom:6}}>
              <span style={{color:C.grey}}>📎</span>
              <span style={{color:C.white,fontSize:13,flex:1,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{f.label||f.name}</span>
              {f.url && <a href={f.url} target="_blank" rel="noopener noreferrer" style={{background:C.blue,color:C.white,borderRadius:8,padding:'4px 10px',fontSize:12,fontWeight:600,textDecoration:'none'}}>פתח</a>}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

// ── Contacts + Tips ───────────────────────────────────────
function ContactsTab({ tripData, docId }) {
  const [contacts, setContacts] = useState(tripData.contacts||[]);
  const tips = tripData.tips||[];
  const [adding, setAdding] = useState(false);
  const [name, setName]     = useState('');
  const [role, setRole]     = useState('');
  const [phone, setPhone]   = useState('');
  const [saving, setSaving] = useState(false);
  const TI = {food:'🍽️',transport:'🚌',safety:'🛡️',general:'💡',money:'💵',culture:'🎭'};
  const TL = {food:'אוכל',transport:'תחבורה',safety:'בטיחות',general:'כללי',money:'כסף',culture:'תרבות'};

  const save = async () => {
    if (!name.trim()) return;
    setSaving(true);
    const entry = {name:name.trim(),role:role.trim(),phone:phone.trim()};
    try {
      await updateDoc(doc(db,'trips',docId), {contacts: arrayUnion(entry)});
      setContacts(prev=>[...prev,entry]);
      setAdding(false); setName(''); setRole(''); setPhone('');
    } catch {}
    setSaving(false);
  };

  return (
    <div style={{padding:16}}>
      {/* מגד שמיים */}
      <div style={{background:`${C.gold}10`,border:`1px solid ${C.gold}40`,borderRadius:14,padding:14,marginBottom:10,display:'flex',alignItems:'center',gap:12}}>
        <div style={{width:44,height:44,borderRadius:'50%',background:`${C.gold}20`,border:`1px solid ${C.gold}40`,display:'flex',alignItems:'center',justifyContent:'center',fontSize:20}}>✈️</div>
        <div style={{flex:1}}>
          <div style={{color:C.gold,fontWeight:700}}>מגד שמיים</div>
          <div style={{color:C.grey,fontSize:12}}>megedshamaim@gmail.com</div>
        </div>
        <a href="mailto:megedshamaim@gmail.com" style={{background:`${C.gold}20`,border:`1px solid ${C.gold}40`,borderRadius:10,padding:8,fontSize:18,textDecoration:'none'}}>✉️</a>
      </div>

      {/* כותרת + הוסף */}
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:8}}>
        <span style={{color:C.white,fontWeight:700}}>👥 אנשי קשר</span>
        <button onClick={()=>setAdding(!adding)} style={{background:'rgba(27,63,139,0.3)',border:'1px solid rgba(27,63,139,0.5)',borderRadius:8,padding:'4px 10px',color:C.grey,fontSize:12,cursor:'pointer'}}>+ הוסף</button>
      </div>

      {adding && (
        <div style={{background:'rgba(27,63,139,0.2)',borderRadius:12,padding:12,marginBottom:10}}>
          <Fld label="שם" value={name} onChange={setName} />
          <Fld label="תפקיד" value={role} onChange={setRole} />
          <Fld label="טלפון" value={phone} onChange={setPhone} mode="numeric" />
          <Btn label={saving?'שומר...':'שמור'} onClick={save} disabled={saving} />
        </div>
      )}

      {contacts.map((ct,i)=>(
        <div key={i} style={{background:'rgba(27,63,139,0.15)',border:'1px solid rgba(27,63,139,0.4)',borderRadius:12,padding:12,marginBottom:8,display:'flex',alignItems:'center',gap:10}}>
          <div style={{width:40,height:40,borderRadius:'50%',background:'rgba(27,63,139,0.4)',display:'flex',alignItems:'center',justifyContent:'center',color:C.beige,fontSize:18}}>👤</div>
          <div style={{flex:1}}>
            <div style={{color:C.white,fontWeight:600}}>{ct.name}</div>
            {ct.role  && <div style={{color:C.grey,fontSize:12}}>{ct.role}</div>}
            {ct.phone && <div style={{color:C.grey,fontSize:12}}>{ct.phone}</div>}
          </div>
          {ct.phone && <a href={`https://wa.me/${ct.phone.replace(/\D/g,'')}`} target="_blank" rel="noopener noreferrer" style={{background:'#22C55E20',border:'1px solid #22C55E40',borderRadius:10,padding:8,fontSize:18,textDecoration:'none'}}>💬</a>}
        </div>
      ))}

      {tips.length>0 && (
        <>
          <div style={{color:C.white,fontWeight:700,margin:'16px 0 8px'}}>💡 טיפים לטיול</div>
          {tips.map((tip,i)=>(
            <div key={i} style={{background:'rgba(27,63,139,0.12)',border:'1px solid rgba(27,63,139,0.3)',borderRadius:12,padding:12,marginBottom:8,display:'flex',gap:10}}>
              <span style={{fontSize:20}}>{TI[tip.category]||'💡'}</span>
              <div>
                <div style={{color:C.grey,fontSize:11,fontWeight:600}}>{TL[tip.category]||'כללי'}</div>
                <div style={{color:C.white,fontSize:13}}>{tip.text}</div>
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
}

// ── Expenses ──────────────────────────────────────────────
function ExpensesTab({ tripData, docId }) {
  const [expenses, setExpenses] = useState(tripData.expenses||[]);
  const lc = tripData.localCurrency||'';
  const [adding, setAdding]   = useState(false);
  const [cat, setCat]         = useState('');
  const [amount, setAmount]   = useState('');
  const [currency, setCurrency] = useState('LOCAL');
  const [note, setNote]       = useState('');
  const [saving, setSaving]   = useState(false);
  const CATS = [
    {id:'flight',label:'טיסה',icon:'✈️'},{id:'hotel',label:'מלון',icon:'🏨'},
    {id:'car',label:'רכב',icon:'🚗'},{id:'restaurant',label:'מסעדה',icon:'🍽️'},
    {id:'shopping',label:'קניות',icon:'🛍️'},{id:'taxi',label:'מונית',icon:'🚕'},
    {id:'other',label:'אחר',icon:'📌'},
  ];
  const ci  = (id) => CATS.find(c=>c.id===id)||{icon:'📌',label:id};
  const sym = (c)  => c==='ILS'?'₪':c==='USD'?'$':lc||'';
  const total = expenses.reduce((s,e)=>s+(e.amountILS||0),0);

  const saveExp = async () => {
    if (!cat||!amount) return;
    setSaving(true);
    const entry = {id:Date.now().toString(),category:cat,currency,amount,note,date:new Date().toISOString().split('T')[0],amountILS:null,customCategory:''};
    try {
      await updateDoc(doc(db,'trips',docId), {expenses: arrayUnion(entry)});
      setExpenses(prev=>[...prev,entry]);
      setAdding(false); setCat(''); setAmount(''); setNote('');
    } catch {}
    setSaving(false);
  };

  return (
    <div style={{padding:16}}>
      {/* סיכום */}
      <div style={{background:`linear-gradient(135deg,${C.blue},${C.mid})`,borderRadius:18,padding:16,marginBottom:16,boxShadow:'0 4px 16px rgba(27,63,139,0.4)',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
        <div>
          <div style={{color:C.grey,fontSize:12}}>סה"כ הוצאות</div>
          <div style={{color:C.gold,fontSize:30,fontWeight:900}}>₪ {total.toFixed(0)}</div>
          {lc && <div style={{color:C.grey,fontSize:11}}>מטבע מקומי: {lc}</div>}
        </div>
        <button onClick={()=>setAdding(!adding)} style={{background:`${C.gold}20`,border:`1px solid ${C.gold}50`,borderRadius:12,padding:'8px 14px',color:C.gold,fontWeight:700,fontSize:13,cursor:'pointer'}}>
          + חדשה
        </button>
      </div>

      {adding && (
        <div style={{background:'rgba(27,63,139,0.2)',borderRadius:14,padding:14,marginBottom:14}}>
          <div style={{display:'flex',flexWrap:'wrap',gap:8,marginBottom:12}}>
            {CATS.map(c=>(
              <button key={c.id} onClick={()=>setCat(c.id)} style={{background:cat===c.id?`${C.gold}20`:'rgba(27,63,139,0.3)',border:`1px solid ${cat===c.id?C.gold:'rgba(27,63,139,0.5)'}`,borderRadius:10,padding:'6px 10px',cursor:'pointer',color:cat===c.id?C.gold:C.grey,fontSize:13}}>
                {c.icon} {c.label}
              </button>
            ))}
          </div>
          <div style={{display:'flex',gap:8,marginBottom:12}}>
            {[{code:'LOCAL',label:lc||'מקומי'},{code:'USD',label:'$'},{code:'ILS',label:'₪'}].map(o=>(
              <button key={o.code} onClick={()=>setCurrency(o.code)} style={{flex:1,background:currency===o.code?`${C.gold}20`:'rgba(27,63,139,0.3)',border:`1px solid ${currency===o.code?C.gold:'rgba(27,63,139,0.5)'}`,borderRadius:10,padding:8,cursor:'pointer',color:currency===o.code?C.gold:C.grey,fontWeight:700}}>
                {o.label}
              </button>
            ))}
          </div>
          <Fld label="סכום" value={amount} onChange={setAmount} mode="decimal" />
          <Fld label="הערה" value={note} onChange={setNote} />
          <Btn label={saving?'שומר...':'הוסף הוצאה'} onClick={saveExp} disabled={saving||!cat||!amount} gold />
        </div>
      )}

      {[...expenses].reverse().map((e,i)=>{
        const c = ci(e.category);
        return (
          <div key={i} style={{background:'rgba(27,63,139,0.12)',border:'1px solid rgba(27,63,139,0.3)',borderRadius:12,padding:12,marginBottom:8,display:'flex',alignItems:'center',gap:10}}>
            <span style={{fontSize:22}}>{c.icon}</span>
            <div style={{flex:1}}>
              <div style={{color:C.white,fontWeight:600,fontSize:13}}>{c.label}</div>
              {e.note && <div style={{color:C.grey,fontSize:12}}>{e.note}</div>}
              <div style={{color:C.greyDk,fontSize:11}}>{fmtDate(e.date)}</div>
            </div>
            <div style={{textAlign:'left'}}>
              <div style={{color:C.white,fontWeight:700}}>{sym(e.currency)} {e.amount}</div>
              {e.amountILS>0 && <div style={{color:C.gold,fontSize:11}}>₪ {Number(e.amountILS).toFixed(0)}</div>}
            </div>
          </div>
        );
      })}
      {!expenses.length && <Empty icon="💸" text="אין הוצאות עדיין" />}
    </div>
  );
}

// ── Bottom Nav ────────────────────────────────────────────
function BottomNav({ tab, setTab }) {
  return (
    <div style={{background:C.navy,borderTop:'1px solid rgba(27,63,139,0.4)',display:'flex',padding:'8px 0 max(4px,env(safe-area-inset-bottom))',flexShrink:0}}>
      {[
        {id:'home',icon:'🏠',label:'בית'},
        {id:'itinerary',icon:'🗺️',label:'מסלול'},
        {id:'docs',icon:'📁',label:'מסמכים'},
        {id:'contacts',icon:'👥',label:'קשר'},
        {id:'expenses',icon:'💸',label:'הוצאות'},
      ].map(({id,icon,label})=>(
        <button key={id} onClick={()=>setTab(id)} style={{flex:1,background:'none',border:'none',cursor:'pointer',display:'flex',flexDirection:'column',alignItems:'center',gap:2,padding:'4px 0'}}>
          <span style={{fontSize:20}}>{icon}</span>
          <span style={{fontSize:10,color:tab===id?C.white:C.greyDk,fontWeight:tab===id?700:400}}>{label}</span>
          {tab===id && <div style={{width:4,height:4,borderRadius:'50%',background:C.gold}} />}
        </button>
      ))}
    </div>
  );
}

// ── Helpers ───────────────────────────────────────────────
function Fld({ label, placeholder, value, onChange, mode, secret }) {
  return (
    <div style={{marginBottom:14}}>
      {label && <div style={{color:C.grey,fontSize:12,marginBottom:6}}>{label}</div>}
      <input
        type={secret?'password':mode==='decimal'?'number':'text'}
        inputMode={mode||'text'}
        placeholder={placeholder}
        value={value}
        onChange={e=>onChange(e.target.value)}
        dir={mode==='numeric'||mode==='decimal'?'ltr':'rtl'}
        style={{
          width:'100%',background:'rgba(27,63,139,0.2)',
          border:'1px solid rgba(27,63,139,0.5)',borderRadius:12,
          padding:'12px 14px',color:C.white,fontSize:15,
          outline:'none',boxSizing:'border-box',
        }}
      />
    </div>
  );
}

function Btn({ label, onClick, disabled, gold }) {
  return (
    <button onClick={onClick} disabled={disabled} style={{
      width:'100%',padding:14,borderRadius:14,border:'none',
      background:disabled?(gold?`${C.gold}50`:C.greyDk):(gold?`linear-gradient(135deg,${C.gold},#b8860b)`:`linear-gradient(135deg,${C.blue},${C.mid})`),
      color:gold?C.navy:C.white,fontWeight:700,fontSize:16,
      cursor:disabled?'default':'pointer',
      boxShadow:disabled?'none':gold?'0 4px 16px rgba(212,160,23,0.4)':'0 4px 16px rgba(27,63,139,0.4)',
    }}>{label}</button>
  );
}

function ErrBox({ msg }) {
  return (
    <div style={{background:'#EF444420',border:'1px solid #EF444450',borderRadius:12,padding:'10px 14px',color:C.red,fontSize:13,marginBottom:16}}>
      ⚠️ {msg}
    </div>
  );
}

function Empty({ icon, text }) {
  return (
    <div style={{textAlign:'center',padding:40}}>
      <div style={{fontSize:40,marginBottom:12}}>{icon}</div>
      <div style={{color:C.grey}}>{text}</div>
    </div>
  );
}

export default TripPortalModal;